import React from "react";

function TabsButtons({tabs, activeTab, setActiveTab}) {
  return (
    <div className="overflow-x-auto pb-1 -mb-px">
      <div className="flex space-x-1 sm:space-x-4 border-b border-gray-200 mb-6 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center whitespace-nowrap px-3 py-2 border-b-2 font-medium text-xs sm:text-sm ${
              activeTab === tab.id
                ? "border-blue-900 text-blue-900"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            <tab.icon className="mr-1 sm:mr-2 h-4 w-4" />
            <span className="hidden xs:inline">{tab.name}</span>
            <span className="xs:hidden">{tab.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default TabsButtons;
